<template>
  <th :class="{ 'fitwidth': fitWidth }">
    <template v-if="header">
      <div class="clickable d-flex align-center" @click="sortTable">
        <span class="header">{{ header }}</span>
        <app-material-icon
          v-if="sorting.name === columnName && sorting.order === 'ASC'"
          name="arrow_downward"
          color="grey-700"
        />
        <app-material-icon
          v-if="sorting.name === columnName && sorting.order === 'DESC'"
          name="arrow_upward"
          color="grey-700"
        />
      </div>
    </template>
  </th>
</template>

<script>
export default {
  name: 'ProjectsTableHeader',
  props: {
    columnName: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: false,
    },
    fitWidth: {
      type: Boolean,
      default: () => true,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sorting: {
        name: '',
        order: '',
      },
    }
  },
  methods: {
    sortTable () {
      if (!this.sortable) return
      this.sorting = {
        name: this.columnName,
        order: this.sorting.order === 'ASC' ? 'DESC' : 'ASC',
      }
      this.$emit('sort', this.sorting)
    },
  },
}
</script>

<style scoped lang="scss">
th {
  border-bottom: thin solid rgba(0, 0, 0, .12);
  text-align: left;
  padding: 18px 24px 10px;

  &:first-child {
    padding-left: 16px;
  }

  @media (max-width: 1600px) {
    padding-left: 14px;
    padding-right: 14px;
  }
}

.header {
  font-size: 14px;
  text-transform: uppercase;
  color: rgb(var(--v-theme-accent));
  margin-right: 8px;
  line-height: 16px;
}
</style>
